<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row">
                <div class="col-md-10">
                    <h6>Configuración de precios</h6>
                </div>
                <div class="col-md-2">
                    <argon-button
                    class="mt-4"
                    variant="gradient"
                    color="info"
                    fullWidth
                    size="xs"
                    @click="toCreate"
                    >Agregar Nuevo</argon-button> 
                </div>
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Código</th>
                            <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >Descripción</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >No. de exámenes</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Descuento</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Total</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Estado</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Se muestra primero</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(
                            {
                                id,
                                code,
                                description,
                                discount,
                                total,
                                tests,
                                first,
                                active
                            },
                            index
                            ) of prices"
                            :key="index"
                        > 
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div>
                                    
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{ code }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div>
                                    
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{ description }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0">{{ tests }}</p>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0">{{ parseInt(discount)+'%' }}</p>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0">{{ parseFloat(total).toFixed(2) }}</p>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0" v-if="active=='t'">Activo</p>
                            <p class="text-xs font-weight-bold mb-0" v-if="active=='f'">Inactivo</p>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0" v-if="first=='t'">Si</p>
                            <p class="text-xs font-weight-bold mb-0" v-if="first=='f'">No</p>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0">{{ toatal }}</p>
                            </td>
                            <td class="align-middle">
                            <a
                                :href="'edit-test/'+id"
                                class="btn bg-gradient-info"
                                data-toggle="tooltip"
                                data-original-title="Edit user"
                            ><i class="fa fa-edit text-white text-sm opacity-10"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
  
<script>
import ArgonButton from "@/components/ArgonButton.vue";

export default {
    name: "tests-table",
    props: {
        prices: [],
    },
    components: { ArgonButton },
    methods:{
        toCreate(){
            this.$router.push('/create-price')
        },
    }
};
</script>
  